
































import {
  Component,
  Prop,
  Vue
} from "../vuepack";
import Button from "./ui/Button.vue";
import {
  RevealPersonalInformationRequest,
  RevealType
} from "@/shared/types";
import { Validator } from "vee-validate";
import { useNotifierStore } from "@/shared/store/notifier";
import { useRevealPersonalInformationStore } from "@/shared/store/revealPersonalInformation";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    Button
  }
})
export default class SsnReveal extends Vue {
  revealStore = useRevealPersonalInformationStore();
  themeStore = useThemeStore();
  notifierStore = useNotifierStore();

  @Prop()
  cognito: string;

  $validator: Validator;
  reasonComment = "";
  showModal = false;

  mounted () {
    this.revealStore.resetState();
  }

  get ssn () {
    if (this.revealStore.revealedInformation) return this.revealStore.revealedInformation.sensitiveInformation;
    return "not found";
  }

  confirmRevealModal () {
    this.$validator
        .validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          this.showModal = false;
          const revealFormModel: RevealPersonalInformationRequest = {
            reason: this.reasonComment,
            revealType: RevealType.SocialSecurityNumber,
            revealForUserName: this.cognito
          };
          this.revealStore.adminPortalRevealPersonalInformation(revealFormModel)
              .then()
              .catch(err => {
                if (err && err.message) {
                  this.notifierStore.setDanger(err.message);
                }
              });
        });
  }

  displayModal () {
    this.showModal = true;
  }

  close () {
    this.showModal = false;
    this.reasonComment = null;
  }
}
